// extracted by mini-css-extract-plugin
export default {"button":"LangButton_button__FimHu","active_button":"LangButton_active_button__1DaSk","lang_image":"LangButton_lang_image__bHCOG"};